/// <reference path="./typings/jquery/index.d.ts" />

import Form from "./Form";
import Menu from "./Menu";
import Maps from "./Maps";
import Utils from "./Utils";
import Sliders from "./Sliders";
import User from "./User";


$(() => {
    console.log("Application ready");

    let form = new Form();
    let menu = new Menu();
    let maps = new Maps();
    let sliders = new Sliders();
    let user = new User();

    $(window).trigger('resize');
    $(window).trigger('scroll');

    $(".parent-center").parent().addClass('center-child-column');

    $(window).on('load', function(){
        (<any>$(".masonry-content")).masonry({
            itemSelector: '.masonry-item',
            transitionDuration: 0
        });
    });

    (<any>$)(".lightbox-link").fancybox();
});